import { useMemo } from 'react';
import type { CommaDelimitedLocationType, LocationType } from '../types';
import LocationControl from '@grnhse/location-control';

export const useLocationControl = (
  locationType: CommaDelimitedLocationType
): LocationControl => {
  return useMemo(() => {
    return new LocationControl({
      ...window.LocationControl.Providers.Pelias,
      locationTypes: locationType.split(',') as LocationType[],
    });
  }, [locationType]);
};
